import AnimationZoom from "./AnimationZoom";

export default AnimationZoom;
